module.exports = __webpack_public_path__ + "img/四星特级大师@2x.88bb8d7f.png";